(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halloween-overlay"] && !Shopify.designMode) return;
  try {
    const halloweenScenes = document.querySelectorAll('[data-halloween-scene]');
  const halloweenHelpButtons = document.querySelectorAll('[data-halloween-help]');
  const halloweenDate = new Date();
  const halloweenMonth = halloweenDate.getMonth();
  const halloweenDay = halloweenDate.getDate();
  const halloweenActive =
    (halloweenMonth === 8 && halloweenDay >= 15) ||
    halloweenMonth === 9 ||
    (halloweenMonth === 10 && halloweenDay <= 3);

  document.documentElement.classList.toggle('halloween-active', halloweenActive);

  halloweenScenes.forEach((scene) => {
    scene.hidden = !halloweenActive;
  });

  halloweenHelpButtons.forEach((button) => {
    button.hidden = !halloweenActive;

    const toggle = button.querySelector('.halloween-monster-help');
    const panel = button.querySelector('.halloween-help__panel');
    toggle?.addEventListener('click', (event) => {
      event.preventDefault();
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  });

  let halloweenPointerFrame;
  document.addEventListener('pointermove', (event) => {
    if (!halloweenActive || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (halloweenPointerFrame) cancelAnimationFrame(halloweenPointerFrame);
    halloweenPointerFrame = requestAnimationFrame(() => {
      document.body.style.setProperty('--halloween-pointer-x', `${(event.clientX / window.innerWidth) * 100}%`);
      document.body.style.setProperty('--halloween-pointer-y', `${(event.clientY / window.innerHeight) * 100}%`);
    });
  }, { passive: true });
  } catch(e) { console.error(e); }
})();

})();
